import React, { useState, useEffect } from 'react';
import { Typography, Layout, Avatar, Tooltip, Button } from 'antd';
import {
  UserOutlined,
  LogoutOutlined
} from '@ant-design/icons';
import AgentConfigService from '../services/AgentConfigService';
import EnvVersionLabel from './Envversionlabel';
import TabNavigation from './TabNavigation';

const { Title } = Typography;
const { Header, Sider, Content } = Layout;

/**
 * HCCAICodeReview - AI Code Review page for the HCC Workspace
 *
 * Blank shell — content will be added later.
 *
 * @param {Object} props
 * @param {string} props.username
 * @param {string} props.sessionId
 * @param {string} props.userRole
 * @param {Array}  props.userFeatures
 * @param {Array}  props.tabOrder
 * @param {function} props.onLogout
 */
const HCCAICodeReview = ({ username, sessionId, userRole, userFeatures, tabOrder, onLogout }) => {

  const [features, setFeatures] = useState(userFeatures || ['HUB', 'COLAB', 'HCC', 'HCC_CONFIG']);
  const [localTabOrder, setLocalTabOrder] = useState(
    tabOrder || ['HUB', 'HCC', 'HCC_CONFIG', 'COLAB', 'MCP', 'COUNSEL']
  );

  useEffect(() => {
    const refreshFeatures = async () => {
      try {
        const mainApiUrl = await AgentConfigService.getMainApiUrl();
        const response = await fetch(`${mainApiUrl}/features`, {
          headers: { 'Authorization': `Bearer ${sessionId}` },
          credentials: 'include'
        });

        if (response.ok) {
          const { features: serverFeatures } = await response.json();
          setFeatures(serverFeatures);
        }

        if (response.tab_order) {
          setLocalTabOrder(response.tab_order);
        }
      } catch (error) {
        console.warn('Failed to refresh features, using fallback:', error);
        setFeatures(['HUB', 'COLAB', 'HCC', 'HCC_CONFIG']);
      }
    };

    if (sessionId && !userFeatures) {
      refreshFeatures();
    }
  }, [sessionId, userFeatures]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {/* ---------- Left Sidebar ---------- */}
      <Sider
        width={60}
        collapsible
        collapsed={true}
        collapsedWidth={60}
        trigger={null}
        className="sidebar-gradient"
        style={{
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          bottom: 0,
          zIndex: 10
        }}
      >
        <div
          style={{
            display: 'flex',
            background: 'linear-gradient(180deg, #162349 0%, #2a4a7c 100%)',
            flexDirection: 'column',
            justifyContent: 'space-between',
            height: '100%',
            alignItems: 'center',
            padding: '20px 0'
          }}
        >
          <div></div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px', alignItems: 'center' }}>
            <Tooltip title={username} placement="right">
              <Avatar
                style={{
                  backgroundColor: 'white',
                  color: '#162349',
                  cursor: 'pointer',
                  border: '2px solid white'
                }}
                icon={<UserOutlined />}
              />
            </Tooltip>

            <Tooltip title="Logout" placement="right">
              <Button
                type="text"
                icon={<LogoutOutlined style={{ color: 'white' }} />}
                onClick={onLogout}
                style={{ color: 'white' }}
              />
            </Tooltip>

            <EnvVersionLabel
              style={{
                color: 'rgba(255,255,255,0.6)',
                fontSize: '12px',
                fontWeight: 'Bold'
              }}
            />
          </div>
        </div>
      </Sider>

      {/* ---------- Main Layout ---------- */}
      <Layout style={{ marginLeft: '60px' }}>
        <Header
          style={{
            background: '#162349',
            padding: '8px 24px 0 24px',
            height: 'auto',
            color: 'white'
          }}
        >
          <div style={{ display: 'flex', alignItems: 'flex-end', gap: '0' }}>
            <TabNavigation
              features={features}
              activeTab="HCC_CODER_REQUESTED_REVIEW"
              tabOrder={localTabOrder}
            />
          </div>
        </Header>

        <Content
          style={{
            padding: '24px',
            background:
              'linear-gradient(to bottom, #f8f9fa 0%, #f0f2f5 33%, #ced4da 90%, #ced4da 100%)'
          }}
        >
          <Title level={1} style={{ marginBottom: '40px', fontSize: '28px', textAlign: 'left' }}>
            AI Code Review
          </Title>

          {/* Content will be added later */}

        </Content>
      </Layout>
    </Layout>
  );
};

export default HCCAICodeReview;